module.exports = __webpack_public_path__ + "img/nav_bottom_folder.5a30c55a.png";